import { Modal } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { CollaborationsForm } from '../forms/CollaborationsForm';

type CollaborationsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const CollaborationsModal = ({ isOpen, onClose }: CollaborationsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      title={t('common.addType', {
        type: t('collaborations.cooperationSchool'),
      })}
      width='s'
    >
      <CollaborationsForm onClose={onClose} />
    </Modal>
  );
};
